module.exports = __webpack_public_path__ + "img/emoji_91.4d2b669e.png";